import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IgmsAlertData } from 'src/app/shared/dialogs/gms-alert/gms-alert.component';
import { GmsdialogService } from 'src/app/shared/services/gmsdialog.service';
import { AuthenticationService } from '../services/authentication.service';
import { GmsmenuService } from '../services/gmsmenu.service';
@Injectable()
export class SessionvalidationInterceptor implements HttpInterceptor {

  constructor(private authSer: AuthenticationService, private router: Router,
    private gmsDilogSer: GmsdialogService, private gmsMenusSer: GmsmenuService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request)
      .pipe(map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (event?.body?.data != undefined && (event?.body?.data?.length == 0 || event?.body?.data == null)) {
            const data: IgmsAlertData = {
              message: 'No Data Available',
              buttonText: 'CLOSE',
              title: ""
            };
            this.gmsDilogSer.showAlert(data, "330px");
          }

        }
        if (event instanceof HttpResponse && ~~(event.status / 100) > 3) {
        } else {
          // console.info('event =', event, ';');
        }
        return event;
      }),
        catchError((error: HttpErrorResponse) => {
          let errorMsg = '';
          if (error.error instanceof ErrorEvent) {
            console.log('this is client side error');
            errorMsg = `Error: ${error.error.message}`;
          }
          else {
            console.log('this is server side error', error);
            if (error.error.message === "Invalid Session Key, User Not Logged in") {
              const data: IgmsAlertData = {
                message: 'Invalid Session Key, User Not Logged in, Session Expired',
                buttonText: 'CLOSE',
                title: "Error"
              };
              this.gmsDilogSer.showAlert(data, "330px");
              this.authSer.sessionValue = null;
              this.authSer.clearSession();
              sessionStorage.clear();
              sessionStorage.removeItem("userName");
              this.gmsMenusSer.clearGmsMenuSession();
              this.router.navigate(['/login']);
            } else if (error.error['Error'] == "User Access Denied!") {
              const data: IgmsAlertData = {
                message: 'User Access Denied!',
                buttonText: 'CLOSE',
                title: "Error"
              };
              this.gmsDilogSer.showAlert(data, "330px");
            } else if (error.status === 401 || error.status === 400 || error.status === 500) {
              // errorMsg = `Error Code: ${error.status},  Message: ${error.message}`;
              //  this.router.navigate(['/login']);
              const data: IgmsAlertData = {
                message: 'Oops!! Something went wrong. Please check the input values and try again.',
                buttonText: 'CLOSE',
                title: "Error"
              };
              this.gmsDilogSer.showAlert(data, "330px");
            } else if (error.status === 403) {
              const data: IgmsAlertData = {
                message: 'Access denied',
                buttonText: 'CLOSE',
                title: "Error"
              };
              this.gmsDilogSer.showAlert(data, "330px");
            } else if (error.status === 0 && error.statusText == "Unknown Error") {
              const data: IgmsAlertData = {
                message: 'Has been blocked by CORS policy or Unknown Error',
                buttonText: 'CLOSE',
                title: "Error"
              };
              this.gmsDilogSer.showAlert(data, "330px");
            }
          }
          console.log(errorMsg);
          return throwError(() => error);
        })
      ) as any;
  }
  private modifyBody(body: any) {
    // console.log('boyd:', body);
  }
}
